import { Layout } from 'antd';
import { TaskCenter } from '../components/task-center';
import { TopNavigation } from '../components/top-navigation';

const { Header } = Layout;

interface AppHeaderProps {
  selectedKey?: string;
}

export const AppHeader = ({ selectedKey }: AppHeaderProps) => {
  return (
    <Header className='bg-white shadow-sm'>
      <div className='flex items-center justify-between h-full gap-4'>
        <TopNavigation selectedKey={selectedKey} />
        <TaskCenter />
      </div>
    </Header>
  );
};
